/**
 * ToastContainer - manages multiple toast notifications
 */

import React, { useState, useCallback } from "react";
import { Toast, ToastProps } from "./Toast";

interface ToastItem extends ToastProps {
  id: string;
}

export const ToastContainer: React.FC = () => {
  const [toasts, setToasts] = useState<ToastItem[]>([]);

  const removeToast = useCallback((id: string) => {
    setToasts((prev) => prev.filter((t) => t.id !== id));
  }, []);

  // Listen for custom toast events
  React.useEffect(() => {
    const handleToastEvent = (e: CustomEvent) => {
      const { message, type = "info", duration = 3000 } = e.detail;
      const id = `toast-${Date.now()}-${Math.random()}`;
      setToasts((prev) => [...prev, { id, message, type, duration }]);
    };

    window.addEventListener("show-toast" as any, handleToastEvent);
    return () => window.removeEventListener("show-toast" as any, handleToastEvent);
  }, []);

  return (
    <>
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          message={toast.message}
          type={toast.type}
          duration={toast.duration}
          onClose={() => removeToast(toast.id)}
        />
      ))}
    </>
  );
};

// Helper function to show toasts from anywhere
export function showToast(message: string, type: "success" | "error" | "info" | "warning" = "info", duration = 3000) {
  window.dispatchEvent(new CustomEvent("show-toast", {
    detail: { message, type, duration }
  }));
}
